import React from 'react';
import { Navbar, Nav, NavItem } from 'reactstrap';
//import SourceLink from 'components/SourceLink';

const app_year = process.env.REACT_APP_YEAR;
const app_name = process.env.REACT_APP_NAME;
const app_version = process.env.REACT_APP_VERSION;

const Footer = () => {
  return (
    <Navbar className="footer">
      <Nav navbar>
        <NavItem>
          Copyright © 2020-{app_year} {app_name}. All Rights Reserved.
        </NavItem>
      </Nav>
      <span>ver {app_version}</span>
    </Navbar>
  );
};

export default Footer;
